import {
  Box,
  Button,
  ButtonProps,
  SxProps,
  Typography,
  darken,
  styled,
} from '@mui/material';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
  sxProps?: SxProps;
  label: string;
  btnLabel: string;
  linkTo: string;
}

const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.background.paper,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '3px',
  margin: '20px',
  padding: '10px 40px',
  // on hover change background color
  '&:hover': {
    backgroundColor: darken(theme.palette.primary.main, 0.4),
    color: theme.palette.background.paper,
  },
}));

const DashbboardContainer: FC<Props> = observer(props => {
  const { children, sxProps, label, linkTo, btnLabel } = props;

  const navigate = useNavigate();

  return (
    <Box
      width={1}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        backgroundColor: 'secondary.light',
        borderRadius: '3px',
        ...sxProps,
      }}
    >
      <Box paddingTop={3}>
        <Typography
          color="secondary.main"
          fontSize={18}
          fontFamily="BrixSansBold"
        >
          {label}
        </Typography>
      </Box>

      {children}
      <StyledButton variant="contained" onClick={() => navigate(linkTo)}>
        {btnLabel}
      </StyledButton>
    </Box>
  );
});

export default DashbboardContainer;
